import React, { useLayoutEffect, useRef, useState } from "react";
import LazyLoad from 'react-lazyload';
import { Link } from "react-router-dom";

const ProjectCard = ({ data }) => {
    const targetRef = useRef();
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
    const windowSize = useRef([window.innerWidth, window.innerHeight]);
    const monitorWidth = windowSize.current[0];

    console.log(monitorWidth);


    useLayoutEffect(() => {
        if (targetRef.current) {
            setDimensions({
                width: targetRef.current.offsetWidth,
                height: targetRef.current.offsetHeight
            });
        }
    }, []);

    let elHeight = Number(dimensions.height);
    // console.log(typeof elHeight);

    const { img, details, tag, title, path } = data;

    return (
        <div className={`grid-item  ${tag} width-50`} >
            <div className="thumb">
                <LazyLoad 
                className="lazyload-img-height"
                    // style={{height:"49vh"}}
                    height={monitorWidth <= 600 ? 200 : monitorWidth <= 1550 ? 480 : monitorWidth <= 2000 ? 510 : 400} once
                  
                >
                    <img className="item_image" src={img} alt=""
                        style={{objectFit:"cover"}}
                    />
                </LazyLoad>

                <div className="works-info">
                    <div className="label-text">
                        <h6><a href={path}>
                            {title}</a></h6>
                        <h5><Link to={path}>{details}</Link></h5>
                        <div className="details_link"><Link to={path}><span className="link_text">View Details</span> <span className="link_icon"><span className="line"></span> <span className="circle"></span><span className="dot"></span></span></Link></div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default ProjectCard;